var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 18.4C16.0002 19.8359 14.8809 21 13.5002 21C12.1195 21 11.0002 19.8359 11.0002 18.4V11M1.12652 9.40626C1.88973 4.64091 6.01978 1 11.0002 1C15.9806 1 20.1107 4.64091 20.8739 9.40626C20.9484 9.87138 20.9856 10.1039 20.8921 10.3523C20.8177 10.55 20.6355 10.7636 20.4522 10.8684C20.2217 11 19.9479 11 19.4002 11H2.60021C2.05257 11 1.77875 11 1.54826 10.8684C1.36488 10.7636 1.1827 10.55 1.1083 10.3523C1.01478 10.1039 1.05202 9.87138 1.12652 9.40626Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.1ef84b48bec1c90292eb9a8ed324d494.svg";
export { ForwardRef as ReactComponent };